import React from 'react'
import DocumentsWizard from '../DocumentsWizard/DocumentsWizard'
import Documents from '../../ProjectTabs/Documents/Documents'

const DocumentSpecReviewWizard = ({ setDocumentCheck, documentCheck,storeProjectId }: any) => {
    return (
        <div className='row'>
            <div className='col-md-12'>
                <h5 className='mb-2'>Important Note</h5>
                <p>
                    It is essential that all necessary documents are present in the proper folders before this action is
                    taken since some folder permissions are taken away when an action is done. You may place documents
                    in their proper folders directly from this form.
                </p>
            </div>

            <div className='col-md-12 mt-3 mb-3'>
                <div className='d-flex gap-2 align-items-center'>
                    <p className='color-red mb-0'>
                        All necessary documents are present in the proper folders? *
                    </p>
                    <label className="checkboxs mt-1 mb-3">
                        <input
                            type="checkbox"
                            defaultChecked={false}
                            onChange={() => setDocumentCheck(true)}
                            checked={documentCheck}

                        // {...formik.getFieldProps("che")}
                        />
                        <span className="checkmarks" />
                    </label>
                </div>
            </div>
            <div className='col-md-12'>
                <div className=''>
                    <Documents projectId={storeProjectId}/>
                </div>
            </div>
        </div>
    )
}

export default DocumentSpecReviewWizard